import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IMethodsAnalytes } from '../../models/methods-analytes/methods-analytes';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class MethodsAnalytesService {
  private api: string = environment.publicApi + 'MethodsAnalytesMenu/';
  constructor(private http: HttpClient){}

  getMethodAnalytes(searchBy: string, search: string): Observable<IMethodsAnalytes[]> {
    return this.http.get<IMethodsAnalytes[]> (this.api + 'MethodsAnalytes/' +  searchBy + '/' + search,  httpOptions)
  }
}
